<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div ngxUiLoaderBlurred id="main-content">
  <router-outlet></router-outlet>
</div>
<ngx-ui-loader></ngx-ui-loader>
